/**
 * Centre Page age strip — toggles hero taglines and content panels.
 */
(function () {
	'use strict';

	function selectAge(age, clickedButton) {
		var root = document.querySelector('[data-centre-age-strip]');
		if (!root) {
			return;
		}

		document.querySelectorAll('.age-pill').forEach(function (pill) {
			pill.classList.remove('selected');
			pill.setAttribute('aria-pressed', 'false');
		});

		if (clickedButton) {
			clickedButton.classList.add('selected');
			clickedButton.setAttribute('aria-pressed', 'true');
		}

		document.querySelectorAll('[data-age-panel]').forEach(function (panel) {
			panel.classList.remove('is-active');
			panel.hidden = true;
		});

		var panelTarget = document.querySelector('[data-age-panel="' + age + '"]');
		if (panelTarget) {
			panelTarget.classList.add('is-active');
			panelTarget.hidden = false;
		}

		document.querySelectorAll('[data-age-hero]').forEach(function (tagline) {
			tagline.classList.remove('is-active');
		});

		var heroTarget = document.querySelector('[data-age-hero="' + age + '"]');
		if (!heroTarget && 'default' !== age) {
			heroTarget = document.querySelector('[data-age-hero="default"]');
		}
		if (heroTarget) {
			heroTarget.classList.add('is-active');
		}

		// The age strip keeps its generic default state, while Rhythm has no
		// generic panel and therefore falls back to Nursery.
		var rhythmMap = { default: 'nursery', baby: 'nursery', toddler: 'toddler', preschool: 'preschool' };
		if (rhythmMap[age] && typeof window.guardianCentrePageSwitchRhythm === 'function') {
			window.guardianCentrePageSwitchRhythm(rhythmMap[age]);
		}

		if (typeof window.guardianCentrePageSwitchSettling === 'function') {
			window.guardianCentrePageSwitchSettling(age);
		}
	}

	// Page-wide age selection: drives the age strip, rhythm, and settling sections together.
	window.guardianCentrePageSelectAge = function (age) {
		var pill = age && 'default' !== age
			? document.querySelector('.age-pill[data-age-pill="' + age + '"]')
			: null;
		selectAge(age, pill);
	};

	function resetToDefault() {
		selectAge('default', null);
	}

	function init() {
		var pills = document.querySelectorAll('.age-pill[data-age-pill]');
		if (!pills.length) {
			return;
		}

		pills.forEach(function (pill) {
			pill.addEventListener('click', function () {
				var age = pill.getAttribute('data-age-pill');
				if (!age) {
					return;
				}
				selectAge(age, pill);
			});
		});

		resetToDefault();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
